bovoApp.controller('OrderAnalyticController', ['$scope', 'Analytic', 'Account', '$location', 'FileUploader', '$http',
	function ($scope, Analytic, Account, $location, FileUploader, $http) {

		$scope.filterProp = [];

		$scope.filterData = {
			export: false,
			customers: [],
			workers: [],
			workSteps: [],
			page: 1,
			created_at: {
				startDate: null,
				endDate: null
			},
			scheduled_time: {
				startDate: null,
				endDate: null
			}
		}
		$scope.$on('refresh_data', function () {
			console.log('refreshing order reports...')
			$scope.init();
		}, true);

		$scope.$watch('filterData', function () {
			$scope.init();
		}, true);


		$scope.clearFilter = function (page) {
			$scope.filterData = {
				export: false,
				customers: [],
				workers: [],
				workSteps: [],
				page: 1,
				created_at: {
					startDate: null,
					endDate: null
				},
				scheduled_time: {
					startDate: null,
					endDate: null
				}
			}
		}

		$scope.chartColors = [
			'#dbe4e5', 
			'#089e81', 
			'#089e81', 
			'#089e81'
		];
		$scope.init = function (type) {
			Analytic.orders($scope.filterData).success(function (data, status, headers, config) {
				if (typeof type !== undefined && type == 'export') {
					$scope.filterData.export = false;
					window.location.href = data.url;
				} else {
					$scope.data = data;
					$scope.series = ['Oluşturulan', 'Teslimatta', 'Tamamlanan', 'Tamamlanamayan'];
					$scope.barChartData = [
						data.chart.count.created,
						data.chart.count.on_delivery,
						data.chart.count.success,
						data.chart.count.fail,
					];
					$scope.chartData = [
						data.count.created,
						data.count.on_delivery,
						data.count.success,
						data.count.fail,
					];
				}
			});
		};

		$scope.getPage = function (page) {
			$scope.filterData.page = page;
			$scope.filter();
		}

		$scope.export = function (page) {
			$scope.filterData.export = true;
			$scope.init('export');
		}

		$scope.sort = function (field, sort) {
			$scope.filterData.field = field;
			$scope.filterData.sort = sort;
			$scope.filter();
		}

		$scope.filter = function (type) {
			if (type == 'clear') {
				$scope.filterData = {
					export: false,
					customers: [],
					workers: [],
					workSteps: [],
					page: 1,
					created_at: {
						startDate: null,
						endDate: null
					},
					scheduled_time: {
						startDate: null,
						endDate: null
					}
				}
			}
			$scope.init();
		}

	}
]);
